import { useQuery } from '@tanstack/react-query'
import { getAvailableGeneralTicketsForEvent } from 'api/generalTicket'

export interface AvailableGeneralTicketsResponse {
    availableCount: number
    allCount: number
    price: number
    allTickets: {
        ticketId: string
        seatId: string
        status: string
    }[]
    availableTickets: {
        ticketId: string
        seatId: string
        status: string
    }[]
}

export const useGeneralTickets = (eventId: string) => {
    const { data, error, isLoading, refetch } = useQuery<AvailableGeneralTicketsResponse>({
        queryKey: ['generalTickets', eventId],
        queryFn: async () => {
            if (!eventId) throw new Error('No event ID provided')
            return getAvailableGeneralTicketsForEvent(eventId)
        },
        enabled: !!eventId,
    })

    return {
        data,
        error,
        isLoading,
        refetch,
    }
}
